<template>
  <div>
      <h4>
    {{ $t('resguardo.confirmacion') }}
      </h4>
  <div>
    <h5 >{{ $t('resguardo.gracias') }}</h5>
    <p>
        {{$t('resguardo.numero_pedido')}} {{this.numero}}
    </p>
      </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      numero: "",
    };
  },
  mounted() {
    //Esto ahora redirige al pago
    //console.log("NUMERO ==", this.$route.params.numero);
    this.numero = this.$route.params.numero;
    setTimeout(() => window.location = this.$route.params.url, 1000);
  },
};
</script>

<style>
</style>
